import React, { useEffect, useRef, useState } from 'react';
import classes from './CameraTableLayout.module.css';
import tableClasses from '../Table/Table/EventsTable.module.css';
import BasicTable from './Table/Table';
import Pill_Widget from '../UI/Widgets/Pill_Widget';
import Pill_Widget_2 from '../UI/Widgets/Pill_Widget_2';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { serviceActions } from '../../store/service-Slice';
import useSetCookie from '../hooks/UseSetCookie';
import { deleteLiveViewCamera, transferLiveViewCamera, PowerSearchAPI } from '../../Api Methods/Api';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import areYouSure from '../../assets/animations/areYouSure.json'
import loadingAnim from '../../assets/animations/newLoading.json'
import { AutoComplete } from 'primereact/autocomplete';

const CameraTableLayout = ({ data, isloading, groups, filtering, apiData, onRefresh }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log(data);

  const [selectedIds, setSelectedIds] = useState([]);
  const [isUnlinking, setIsUnlinking] = useState(false);
  const [selectedMassAction, setSelectedMassAction] = useState("")
  const [showUnlinkDialog, setShowUnlinkDialog] = useState(false)
  const [showSearchSites, setShowSearchSites] = useState(false)
  const [showLoading, setShowLoading] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [showFail, setShowFail] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)

  const [messageSuccess, setMessageSuccess] = useState("")
  const [messageFail, setMessageFail] = useState("")
  const [currentPosition, setCurrentPosition] = useState(0)
  const [dialogTitle, setDialogTitle] = useState("")
  const [confirmationMessage, setConfirmationMessage] = useState("")

  const [searchTerm, setSearchTerm] = useState("")
  const searchTermRef = useRef("")
  const [suggestions, setSuggestions] = useState([])
  const [selectedSite, setSelectedSite] = useState(null)


  const allIds = (data ?? []).map(c => c.id);
  const selectAll = allIds.length > 0 && allIds.every(id => selectedIds.includes(id));

  const toggleSelectAll = () => {
    setSelectedIds(selectAll ? [] : allIds);
  };

  const toggleRow = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const handleUnlink = async () => {
    setShowConfirmation(false);
    setShowLoading(true);
    let failed = false;
    for (let i = 0; i < selectedIds.length; i++) {
      setCurrentPosition(i + 1);
      const res = await deleteLiveViewCamera(apiData, selectedIds[i], dispatch);
      if (res && !res.success) {
        failed = true;
      }
      if (i < selectedIds.length - 1) await delay(500);
    }
    setShowLoading(false);
    if (failed) {
      setShowFail(true);
    } else {
      setShowSuccess(true);
    }
    if (onRefresh) onRefresh();
  };

  const handleTransfer = async () => {
    const siteUUID = selectedSite?.uuid ?? searchTermRef.current;
    setShowSearchSites(false);
    setShowLoading(true);
    let failed = false;
    for (let i = 0; i < selectedIds.length; i++) {
      setCurrentPosition(i + 1);
      const body = { cameraID: selectedIds[i], siteUUID };
      const res = await transferLiveViewCamera(apiData, body, dispatch);
      if (res && !res.success) {
        failed = true;
      }
      if (i < selectedIds.length - 1) await delay(500);
    }
    setShowLoading(false);
    if (failed) {
      setShowFail(true);
    } else {
      setShowSuccess(true);
    }
    setSearchTerm("");
    searchTermRef.current = "";
    setSelectedSite(null);
    setSuggestions([]);
    if (onRefresh) onRefresh();
  };

  const dropdownOptions = [
    "Unlink cameras",
    "Transfer cameras"
  ]

  useEffect(() => {
    console.log(selectedMassAction);
    if (selectedMassAction != ""){
      switch(selectedMassAction) {
        case "Unlink cameras":
          setConfirmationMessage(`Are you sure you want to unlink ${selectedIds.length} cameras?`)
          setDialogTitle("Unlink cameras")
          setShowConfirmation(true)
        break;
        case "Transfer cameras":
          setConfirmationMessage(`Are you sure you want to transfer ${selectedIds.length} cameras?`)
          setDialogTitle("Transfer cameras")
          setShowConfirmation(true)
        break;
      }
    }
  }, [selectedMassAction])

  const HandleUipiodOnClick = (DeviceUUID) => {
    dispatch(serviceActions.setDeviceUUID(DeviceUUID));
    useSetCookie("DeviceUUID", DeviceUUID, 1);
    navigate("/Dashboard/SiteView/" + DeviceUUID);
  };

  const HandleGroupOnClick = (groupName) => {
    const groupClicked = groups?.find(g => g.name === groupName);
    if (groupClicked) {
      sessionStorage.setItem('groupClicked', groupClicked.name);
      sessionStorage.setItem('groupPath', groupClicked.group_path);
      sessionStorage.setItem('groupClickedID', groupClicked.id);
      navigate("/Dashboard/Groups/GroupSites");
    }
  };

  const handleSetNewSite = () => {
    setShowConfirmation(false);
    setShowSearchSites(true);
  };

  const search = (event) => {
    const powerSearch = async (query) => {
      const responseData = await PowerSearchAPI(apiData, query, 50, 1, 0, 0, 0, 0, dispatch);
      const suggestedSites = responseData[0].devices;
      setSuggestions(suggestedSites.map(site => ({ label: site.tag ? `${site.key} — ${site.tag}` : site.key, uuid: site.uuid, key: site.key })));
    };
    powerSearch(event.query);
  };

  const startAction = async () => {
    switch (selectedMassAction){
      case "Unlink cameras" :
        handleUnlink()
      break;

      case "Transfer cameras" :
        handleSetNewSite()
      break;
    }
  }

  const m_names = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

  function formatDate(date) {
    const day = date.getDate();
    const sup = [1, 21, 31].includes(day) ? "st"
      : [2, 22].includes(day) ? "nd"
      : [3, 23].includes(day) ? "rd" : "th";
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const h = hours % 12 || 12;
    const m = minutes < 10 ? '0' + minutes : minutes;
    return `${day}${sup} ${m_names[date.getMonth()]} ${date.getFullYear()}, ${h}:${m} ${ampm}`;
  }

  const companyColors = {
    EyeSpyFX: "rgb(100, 149, 237)",
    RESURE: "rgb(75, 0, 130)",
    PARFAS: "rgb(0, 0, 0)",
    PORTAL_SECURITY: "rgb(0, 0, 139)",
    SOLO: "rgb(178, 34, 34)",
    KNOWIO: "rgb(20, 155, 8)",
    CPS: "rgb(8, 155, 121)",
    CSC_SECURITY: "rgb(8, 150, 155)",
    EES: "rgb(94, 8, 155)"
  };

  const tablecolumns = [
    {
      id: 'name',
      header: () => (
        <div className={classes.tableTitleText} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Checkbox onChange={toggleSelectAll} checked={selectAll} />
          <h3>Camera name</h3>
        </div>
      ),
      accessorKey: 'name',
      cell: (row) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Checkbox
            checked={selectedIds.includes(row.row.original.id)}
            onChange={() => toggleRow(row.row.original.id)}
          />
          <div className={classes.tableValueText}>
            {row.row.original.name}
          </div>
        </div>
      ),
    },
    {
      id: 'type',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Type</h3>
        </div>
      ),
      accessorKey: 'type',
      cell: (row) => {
        let text = '';
        let pillColour = '#6e6e6e';
        switch (row.row.original.type) {
          case 'HIKVISION':
            text = 'Hikvision';
            pillColour = '#616366';
            break;
          case 'DAHUA':
            text = 'Dahua';
            pillColour = '#ee0018';
            break;
          case 'AJAX':
            text = 'AJAX';
            pillColour = '#1a1a1aff';
            break;
          case 'AIBOX':
            text = 'AIBox';
            pillColour = '#00bbf8';
            break;
          default:
            text = row.row.original.type;
        }
        return (
          <div className={classes.tableValueText}>
            <Pill_Widget_2 pillColour={pillColour} text={text} />
          </div>
        );
      },
    },
    {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site name</h3>
        </div>
      ),
      accessorKey: 'tag',
      cell: (row) => {
        const uuid = row.row.original.uuid;
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}>
            <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: 'pointer', width: 'fit-content' }}>
              {row.row.original.tag && row.row.original.tag.trim() !== '' && (
                <Pill_Widget
                  boolean={true}
                  PillColor_IfTrue={"#919191"}
                  PillColor_IfFalse={"#6e6e6e"}
                  text_IfTrue={row.row.original.tag}
                  className={classes.PillHeight}
                />
              )}
            </div>
          </div>
        );
      },
    },
    
    {
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      accessorKey: 'key',
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const key = row.row.original.key;
        return (
          <Link
            onClick={() => HandleUipiodOnClick(uuid)}
            to={`/Dashboard/SiteView/${uuid}`}
            className={classes.tableValueTextBold}
          >
            {key}
          </Link>
        );
      },
    },
    {
      id: 'dateAdded',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Date added</h3>
        </div>
      ),
      accessorKey: 'dateAdded',
      cell: (row) => {
        let dateAdded = formatDate(new Date(row.row.original.dateAdded))
        return (
          <div className={classes.tableValueText}>
            {dateAdded}
          </div>
        )
        
      }
    },
    {
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      accessorKey: 'groupName',
      cell: (row) => {
        let companyName = row.row.original.groupName;
        if (companyName === "RE:SURE") companyName = "RESURE";
        const color = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '200px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: 'pointer',
          }} onClick={() => HandleGroupOnClick(row.row.original.groupName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={color}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.groupName}
              className={classes.PillHeight}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>

    <Dialog
      header={`Transfer ${selectedIds.length} camera${selectedIds.length !== 1 ? 's' : ''} to a new site`}
      visible={showSearchSites}
      style={{ width: "40vw" }}
      onHide={() => { setShowSearchSites(false); setSelectedMassAction(""); }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "8px 0" }}>
        <p style={{ color: "#858585", margin: 0 }}>Type a Site ID or name to search for the destination site.</p>
        <AutoComplete
          value={searchTerm}
          suggestions={suggestions}
          completeMethod={search}
          field="label"
          onChange={(e) => {
            setSearchTerm(e.value);
            if (typeof e.value === "string") {
              searchTermRef.current = e.value;
              setSelectedSite(null);
            }
          }}
          onSelect={(e) => {
            setSelectedSite(e.value);
            searchTermRef.current = e.value.uuid;
          }}
          placeholder="Type to search..."
          appendTo="self"
          panelStyle={{ zIndex: 11000 }}
          style={{ width: "100%" }}
          inputStyle={{ width: "100%" }}
        />
        {selectedSite && (
          <p style={{ color: "#555", margin: 0, fontSize: "14px" }}>
            Selected: <strong>{selectedSite.key}</strong>{selectedSite.label.includes("—") ? ` — ${selectedSite.label.split("— ")[1]}` : ""}
          </p>
        )}
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <Button label="Cancel" icon="pi pi-times" severity="secondary" onClick={() => { setShowSearchSites(false); setSelectedMassAction(""); }} />
          <Button
            label="Transfer"
            icon="pi pi-arrow-right"
            severity="success"
            disabled={!selectedSite && !searchTermRef.current}
            onClick={() => { handleTransfer(); setSelectedMassAction(""); }}
          />
        </div>
      </div>
    </Dialog>
      <Dialog
          header="Success"
          visible={showSuccess}
          style={{ width: "35vw" }}
          onHide={() => {setShowSuccess(false); setSelectedIds([]); setSelectedMassAction([])}}
      >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>              
              <Lottie
                  animationData={successAnim}
                  loop={false}
                  style={{ width: 200, height: 200, margin: "0px" }}
              />
              <p style={{ color: "#6e6e6eff" }}>Action completed successfully</p>
              <br/>
              <Button label="Close" icon="pi pi-times" severity="secondary" onClick={() => {setShowSuccess(false); setSelectedMassAction(""); setSelectedIds([])}} />
          </div>
      </Dialog>

      <Dialog
          header="Error"
          visible={showFail}
          style={{ width: "35vw" }}
          onHide={() => {setShowFail(false); setSelectedMassAction("")}}
      >
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>              
              <Lottie
                  animationData={failAnim}
                  loop={false}
                  style={{ width: 200, height: 200, margin: "0px" }}
              />
              <p style={{ color: "#6e6e6eff" }}>Failed to complete action, please try again</p>
              <br/>
              <Button label="Close" icon="pi pi-times" severity="secondary" onClick={() => {setShowSuccess(false); setSelectedMassAction("")}} />
          </div>
      </Dialog>

      <Dialog header={dialogTitle}
          visible={showLoading} 
          style={{ width: '30vw' }} 
          onHide={() => { if (!showLoading) return; setShowLoading(false); }}>
          <div className="flex flex-col items-center justify-center">

          <p style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center", fontSize:"18px", fontWeight:600 }}>{`Camera ${currentPosition} of ${selectedIds.length}`}</p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Lottie
                animationData={loadingAnim}
                loop
                style={{ width: 250, height: 250 }}
              />
            </div>

            <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
              {messageSuccess || ""}
            </h3>

            <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
              {messageFail || ""}
            </h3>

            <br />
            <br/>
            <Button onClick={() => {setShowLoading(false); setSelectedMassAction("")}} label='Close' severity='danger'/>
          </div>
        </Dialog>

        <Dialog
              header="Are you sure?"
              visible={showConfirmation}
              style={{ width: "40vw" }}
              onHide={() => {setShowConfirmation(false); setSelectedMassAction("")}}
          >
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                  <Lottie
                      animationData={areYouSure}
                      loop={false}
                      style={{ width: 150, height: 150, margin: "0px" }}
                  />
                  <br />
                  <h3 style={{ color: "#6e6e6eff" }}>{confirmationMessage}</h3>
                  <br />
                  <Button label="No, cancel"  icon="pi pi-times" severity="secondary" onClick={() => {setShowConfirmation(false); setSelectedMassAction("")}} />
                  <br />
                  <Button label="Yes" icon="pi pi-check" severity="danger" onClick={() => {startAction(); setSelectedMassAction([])}} />

              </div>
          </Dialog>

  
    <div className={classes.table}>
      <div className={classes['tableCardLayoutUI-wrapper']}>
        {selectedIds.length > 0 && (
          <div className={classes.toolbar}>
            {/* <span className={classes.selectedCount}>{selectedIds.length} camera{selectedIds.length !== 1 ? 's' : ''} selected</span> */}
            {/* <Button
              label={isUnlinking ? 'Unlinking...' : `Unlink ${selectedIds.length} camera${selectedIds.length !== 1 ? 's' : ''}`}
              icon="pi pi-times"
              severity="danger"
              outlined
              disabled={isUnlinking}
              onClick={handleUnlink}
            /> */}
            {selectedIds.length > 0 && <Dropdown 
              value={selectedMassAction} 
              onChange={(e) => setSelectedMassAction(e.value)} 
              options={dropdownOptions}
              placeholder="Select an action" 
              className="w-full md:w-14rem" />}
            {selectedIds.length > 0 && <Button label='Clear selections' outlined severity='danger' icon="pi pi-times" style={{ fontSize: "12px", width: "160px", padding: 12, marginLeft: "15px" }} onClick={() => setSelectedIds([])} />}
              
          </div>
        )}
        {isloading ? (
          <div className={classes['skeleton-list']}>
            {[...Array(10)].map((_, i) => (
              <div key={i} className={classes['skeleton-row']}>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: `${100 + (i % 4) * 30}px`, height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: '80px', height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: '100px', height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: `${80 + (i % 3) * 20}px`, height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: '90px', height: '16px' }} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <BasicTable
            data={data ?? []}
            columns={tablecolumns}
            filtering={filtering || ""}
            rowClick={false}
            ShowPagination={true}
            PageSize={50}
            paginationOptions={[25, 50, 100]}
            tableClasses={tableClasses}
          />
        )}
      </div>
    </div>

    </>
  );
};

export default CameraTableLayout;
